import { render, staticRenderFns } from "./blog-detail.vue?vue&type=template&id=887c7f32"
import script from "./blog-detail.vue?vue&type=script&lang=ts"
export * from "./blog-detail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports